var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('general'),_c('advanced'),_c('main-menu'),_c('assets'),_c('tables')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }